export default __webpack_public_path__ + "images/RC.ff98c6a.png";